import * as React from 'react'

import WeeklySelect from 'modules/automations/components/blocks/WeeklySelect'
import type { Automation } from 'modules/automations/store/models/Automation'

export interface Props {
  automation: Automation
  setDay: (day: number) => void
}

export default function Weekly({ automation, setDay }: Props) {
  const [selectedWeekday, setSelectedWeekday] = React.useState(
    Number(automation.attributes.repeat_data) - 1
  ) // Week day to index

  return (
    <WeeklySelect
      selectedWeekday={selectedWeekday}
      setSelectedWeekday={(day) => {
        setSelectedWeekday(day)
        setDay(day + 1)
      }}
    />
  )
}
